import { sendObject } from './handler';

export type RequestUnlock = { type: 'requestUnlock'; sitId: number };

export const postUnlockRequest = async (sitId: number): Promise<void> =>
  sendObject({ type: 'requestUnlock', sitId });
